var map = {
	"./de/triangleIcon.png": "MKbZ",
	"./en/triangleIcon.png": "MzoM",
	"./es/triangleIcon.png": "vppV",
	"./fr/triangleIcon.png": "GNty",
	"./ja/triangleIcon.png": "Xvf+",
	"./ko/triangleIcon.png": "kYTh",
	"./pt/triangleIcon.png": "B9RL",
	"./ru/triangleIcon.png": "at8X",
	"./tc/triangleIcon.png": "kuwV",
	"./th/triangleIcon.png": "FtHk"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "QqI/";